import React from "react";
import { FieldValues } from "react-hook-form";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";
import FormGenerator from "../../form/FormGenerator";
import { notificationConfigurationApi } from "../../api/notification/notification.service";

interface Props {
    defaultValues: FieldValues;
    handleSubmit: (form_values: any) => void;
    infoComponent: React.ReactNode;
    loading?: boolean;
}

const { useGetAllNotificationModeQuery } = notificationConfigurationApi
const NotificationManagementForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false, infoComponent }) => {
    const { data } = useGetAllNotificationModeQuery({})

    const fields: FormFieldType[] = [
        { type: FormFieldTypesAllowed.Dropdown, multiple: true, label: "Notification Mode", id: "mediums", required: "Field is required", options: (data || []), }
    ];
    return (
        <div>
            {infoComponent}
            <FormGenerator
                defaultValues={defaultValues}
                formFields={fields}
                handleFormSubmit={handleSubmit}
                className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
                loading={loading}
                confirmButtonText="Update"
            />
        </div>
    );
}

export default NotificationManagementForm;